import { formatX, xLevel, type XLevel } from '../lib/format'

const LEVELS: Record<XLevel, string> = {
  x1: 'bg-x1-bg text-x1-fg',
  x2: 'bg-x2-bg text-x2-fg',
  x3: 'bg-x3-bg text-x3-fg',
  x5: 'bg-x5-bg text-x5-fg',
}

interface XBadgeProps {
  value: number
  /** Своя подпись вместо числа, например «×2–3» в легенде. Цвет всё равно по value. */
  label?: string
  className?: string
}

export function XBadge({ value, label, className = '' }: XBadgeProps) {
  return (
    <span
      className={`inline-flex h-5 items-center rounded-md px-1.5 text-xs leading-none font-semibold tabular-nums ${LEVELS[xLevel(value)]} ${className}`}
      title={label ? undefined : `${formatX(value)} к обычному у автора`}
    >
      {label ?? formatX(value)}
    </span>
  )
}
